export default __webpack_public_path__ + "static/media/brand-image-03.2a4318c5.jpg";